<!--
 * @Author: chenyangui
 * @Description: 审批流程 - 付款通知单
-->
<template>
	<div class="apvlPrcPayAdv">
		<header>
			<div style="width:100%">
				<el-row>
					<el-col :span="18">
				<el-form label-width="auto" label-position="left" :inline="true">
					<el-form-item :label="$t('payAdv.salaryMonth'/**工资月份*/)">
						<el-select v-model="wageMonth" :placeholder="$t('payAdv.salaryPlaceholder'/**请选择*/)" @change="handleChangeSelectMonth">
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item style="width: 350px" v-if="isDatePicker">
						 <el-date-picker
							v-model="dateRange"
							type="monthrange"
							value-format="yyyy-MM"
							:range-separator="$t('payAdv.to'/**至*/)"
							:start-placeholder="$t('payAdv.startMonth'/**开始月份*/)"
							:end-placeholder="$t('payAdv.endMonth'/**结束月份*/)"
							@change="handleChangeMonthRange">
						</el-date-picker>
					</el-form-item>
				</el-form>
					</el-col>
					<el-col :span="5" offset=".5" style="text-align:right">
						<div style="display:none" class="right-count"><span>余额：9999</span>&nbsp;&nbsp;<span>留存：999999</span></div>
					</el-col>
				</el-row>
			</div>
		</header>

		<noData v-if="cardList.length === 0" style="text-align: center; margin-top: 200px;" :msg="$t('payAdv.noData'/**暂无数据*/)"></noData>
		<div v-if="cardList.length > 0" class="cardList">
      <el-card class="box-card cardItem" shadow="hover"  v-for="(item, index) in cardList" :key="item.id">
        <header slot="header" class="card-h-wrapper">
          <span class="title" :title="item.title">{{item.title}}</span>
          <span class="s-fx" @click="jumpRouter(item)">{{$t('payAdv.viewDetails'/**查看详情*/)}}</span>
        </header>
        <footer>

          <section class="center" style="margin-bottom: 10px" v-if="item.process && item.process.state > 1">
            <p>
              <img style="margin-bottom: 10px;" v-if="item.process.state==2 || item.process.state==3 || item.process.state==6" src="@/assets/img/salary/wancheng.png">
              <img style="margin-bottom: 10px;" v-else src="@/assets/img/salary/icon-daweiwancheng.png">
            </p>
            <span v-if="item.process.state==2">{{$t('payAdv.proTips1'/**您已提交审批意见, 现在流程到*/)}} {{item.process.processList[item.process.currentIndex].roleName}}</span>
            <span v-if="item.process.state==3">{{$t('payAdv.proTips2'/**已完成审核*/)}}</span>
            <span v-if="item.process.state==4">{{$t('payAdv.proTips3'/**您已驳回审批意见*/)}}</span>
            <span v-if="item.process.state==5">{{$t('payAdv.proTips4'/**未完成*/)}}</span>
            <span v-if="item.process.state==6">{{$t('payAdv.proTips5'/**您创建的薪资批次, 现在流转到*/)}} {{item.process.processList[item.process.currentIndex].roleName}}</span>
            <span v-if="item.process.state==7">{{$t('payAdv.proTips6'/**您创建的薪资批次被驳回, 是*/)}} {{item.process.processList[item.process.currentIndex].roleName}}</span>
          </section>

          <section class="w__text" style="background: #F5F7FA; padding: 10px 10px 0 10px">
            <span v-if="false" class="w__text--width">{{$t('payAdv.totalAmountPayable'/**应付总金额*/)}}: {{item.info.num1}}</span>
            <span v-if="false" class="w__text--width">{{$t('payAdv.useOfFinancialBalance'/**使用财务余额*/)}}: {{item.info.num3}}</span>
            <span class="w__text--width">{{$t('payAdv.totalAmountPaid'/**实付总金额*/)}}: {{item.info.num2}}</span>
            <span v-if="false" class="w__text--width">{{$t('payAdv.useOfCorporateBalance'/**使用对公余额*/)}}: {{item.info.num4}}</span>
          </section>

          <section class="w__tag" style="margin-top: 10px;">
            <span>{{$t('payAdv.approvalProcess'/**审批流程*/)}}: </span>
            <span v-if="!!item.process">
								<el-tag type="success" size="small" v-for="tag in item.process.processList" :key="tag">{{tag.roleName}}</el-tag>
							</span>
          </section>
          <template v-if="item.process && (item.process.state == 1 || item.process.state == 0)">
            <section class="w__tag" style="margin-top: 20px;" v-if="item.process.state == 0">
              <span style="margin-right: 5px;">{{$t('payAdv.confirmation'/**确认意见*/)}}: </span>
              <el-radio-group v-model="item.radio">
                <el-radio :label="1">{{$t('payAdv.confirm'/**确认*/)}}</el-radio>
                <el-radio :label="2">{{$t('payAdv.backToCIIC'/**返回中智*/)}}</el-radio>
              </el-radio-group>
            </section>

            <section class="w__tag" style="margin-top: 20px;" v-if="item.process.state == 1">
              <span style="margin-right: 5px;">{{$t('payAdv.approvalComments'/**审批意见*/)}}: </span>
              <el-radio-group v-model="item.radio">
                <el-radio :label="1">{{$t('payAdv.agree'/**同意*/)}}</el-radio>
                <el-radio :label="2">{{$t('payAdv.reject'/**驳回*/)}}</el-radio>
              </el-radio-group>
            </section>

            <section style="margin-top: 10px;">
              <el-input type="textarea" style="width: 100%;" size="small" :placeholder="$t('payAdv.remarksTips'/**请填写备注*/)" v-model="item.remarks"></el-input>
              <el-button style="margin-top: 10px;" type="primary" @click="submitApproval(item)">{{$t('payAdv.submit'/**提交*/)}}</el-button>
            </section>
          </template>

        </footer>
      </el-card>
		</div>

	</div>
</template>

<script>
/**
 * API
 * - approvalDetails  	列表
 * - submitApproval		提交
 */
import { approvalDetails, submitApproval } from "@/api/wage/approval.js"

/**
 * componets
 * - noData 无数据展示
 */
import noData from "@/wage-components/bsp-noData/bsp-noData.vue"

export default {
  	name: 'apvlPrcPayAdv',

	components: { noData },

	data() {
		return {
			options: Object.freeze([
				{ value: '92480001', label: this.$t('payAdv.currentMonth'/**当前月*/) },
				{ value: '92480002', label: this.$t('payAdv.nearThreeMonth'/**近三个月*/) },
				{ value: '92480003', label: this.$t('payAdv.nearOneYear'/**近一年*/) },
				{ value: '92480004', label: this.$t('payAdv.other'/**其他*/) }
            ]),
			wageMonth: '92480002',  // 月码

			dateRange: [],			// el-date-picker
			isDatePicker: false,	// show/hide
			monthStart: '',			// 开始时间
			monthEnd: '',			// 结束时间

			cardList: [],
			radio: '',				// 当状态为0 勾选
			remarks: '',			// 备注
		}
	},

	mounted() {
		this.approvalDetails()
	},

  	methods: {
		/** API */
		/**
		 * @description 列表
		 */
		approvalDetails() {
			let params = {
				type: '3',
				monthEnd: this.monthEnd,
				monthStart: this.monthStart,
				wageMonth: this.wageMonth,
				batchId: '',
				batchName: '',
				groupId: [],
				monthStr: '92480001',
				socMonth: '',
				taxMonth: '',
				taxType: [],
				limit: 10000,
				page: 1,
				total: 0,
			}
			approvalDetails(params).then(res =>{
				let data = res.data.data
				if (!!data) {
				  data.forEach(item => {
				    console.log(item.state)
          })
					this.cardList = data
				}

			})
		},

		/**
		 * @description 跳转页面
		 */
		jumpRouter(c) {
			this.$router.push({
				path: '/wage/payment/pay-notice/emp-wage-detail',
				query: {
					noticeId: c.noticeId
				}
			})
		},

		/** el-date-picker, el-select */
		/**
		 * @description
		 */
		handleChangeSelectMonth(v) {
			this.dateRange = []
			this.monthStart = ''
			this.monthEnd = ''
			if (v === '92480004') {
				this.isDatePicker = true
			} else {
				this.isDatePicker = false
				this.approvalDetails()
			}
		},

		/**
		 * @description 时间选择参数处理
		 */
		handleChangeMonthRange(r) {
			this.monthStart = !!r ? r[0] : ''
			this.monthEnd = !!r ? r[1] : ''
			!!r && this.approvalDetails()
		},

		/** el-button */
		/**
		 * @description 提交
		 */
  		submitApproval(c) {
			if (c.radio != '2' && c.radio != '1') {
				this.$message.error(this.$t('payAdv.errTips1'/**请勾选审批意见*/))
				return
			}
			if (c.radio == '2' && (!c.remarks || c.remarks.length < 1)) {
				this.$message.error(this.$t('payAdv.errTips2'/**请填写驳回备注*/))
				return
			}
			if (c.remarks && c.remarks.length > 200) {
				this.$message.error(this.$t('payAdv.errTips3'/**备注不能超过200个字符*/))
				return
			}

			this.$confirm(this.$t('areYouSureToSubmit'/**是否确认提交?*/), this.$t('tips'/**提示*/), {
				confirmButtonText: this.$t('determine'/**确定*/),
				cancelButtonText: this.$t('cancel'/**取消*/),
				type: 'warning',
			}).then(() => {
				let params = {
					radio: c.radio,
					adv: c.remarks,
					batchId: c.id,
					type: '3'
				}
				submitApproval(params).then((res) => {
					this.approvalDetails()
					this.$message.success({
						message: this.$t('payAdv.successTips'/**审批完成*/),
						offset: 100,
						type: 'success',
					})
				})
			})
		},
	},
}
</script>

<style lang="scss">
.apvlPrcPayAdv {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  header {
    display: flex;
    justify-content: space-between;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .cardList {
    display: flex;
    gap: 10px;
    /*flex-wrap: wrap;*/
    padding: 0 5px;
  }
  .cardItem {
    margin-bottom: 20px;
    /* ===== 优化：一行 4 个卡片 =====
     * 4 * (25% - 12px) = 100% - 48px，剩余 48px 由 space-between 均分为 3 个 16px 间隙
     */
    width: calc(25% - 12px);
    min-width: 0; /* 防止长标题/标签把卡片撑破 */
    /* ===== 美化：圆角 / 描边 / 过渡 ===== */
    position: relative;
    border-radius: 16px;
    border: 1px solid #eef1f6;
    overflow: hidden;
    transition: transform .28s ease, box-shadow .28s ease, border-color .28s ease;
  }

  /* ===== 美化：卡片顶部品牌色装饰条 ===== */
  .cardItem::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, #93c5fd, #3b82f6);
    z-index: 2;
    opacity: .9;
  }

  /* ===== 美化：hover 抬升 + 柔和投影 =====
   * 修正：原选择器在嵌套中写成 .apvlPrcPayAdv .cardItem.el-card:hover，
   * 编译后需要两层 .apvlPrcPayAdv 祖先，实际不生效，这里改为嵌套内写法
   */
  .cardItem.el-card:hover {
    transform: translateY(-4px);
    border-color: #dbe3ef;
    box-shadow: 0 18px 40px -22px rgba(31, 45, 84, .38) !important;
  }

  .el-date-editor .el-range__close-icon {
    line-height: 20px;
  }

  /* ===== 优化：窗口变窄时自动降列，避免卡片内容被挤压 ===== */
  @media screen and (max-width: 1440px) {
    .cardItem { width: calc(33.3333% - 11px); } /* 3 列 */
  }
  @media screen and (max-width: 1100px) {
    .cardItem { width: calc(50% - 10px); } /* 2 列 */
  }
  @media screen and (max-width: 768px) {
    .cardItem { width: 100%; } /* 1 列 */
  }
}

/* 四列后单卡变窄，最小高度适当下调，避免空白过多 */
.apvlPrcPayAdv .el-card { min-height: 240px; }

.apvlPrcPayAdv .el-card .el-card__body {
  padding: 14px 16px 16px;
  .w__text {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    /* ===== 美化：金额区圆角卡片化（背景/padding 沿用行内 style）===== */
    border-radius: 12px;
    border: 1px solid #eef2f7;
    .w__text--width {
      display: inline-block;
      /* ===== 优化：四列宽度有限，金额独占一行，避免两个金额挤在一起折行错位 ===== */
      width: 100%;
      margin-bottom: 8px;
      font-size: 12px;
      line-height: 18px;
      word-break: break-all;
    }
  }
  .w__tag, .w__text {
    span {
      font-size: 12px;
      font-weight: 600;
    }
  }
  .w__tag {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    /* ===== 优化：标签换行时行间距更紧凑 ===== */
    row-gap: 6px;
    > span:first-child {
      flex-shrink: 0; /* “审批流程：”不换行 */
    }
    .el-tag {
      /* ===== 优化：四列下缩小标签间距，避免撑出卡片 ===== */
      margin: 0 4px 0 0;
      padding: 0 8px;
      height: 22px;
      line-height: 20px;
      font-size: 12px;
      /* ===== 美化：标签药丸化，保留 success 语义色 ===== */
      border-radius: 999px;
      border-color: transparent;
      font-weight: 500;
    }
  }

  /* ===== 优化：单选组在窄卡片内可换行，间距收窄 ===== */
  .el-radio-group {
    display: inline-flex;
    flex-wrap: wrap;
    row-gap: 4px;
    .el-radio {
      margin-right: 14px;
    }
  }

  /* ===== 优化：备注框最小高度，避免过窄卡片里过于局促 ===== */
  .el-textarea__inner {
    min-height: 62px;
  }
}

.apvlPrcPayAdv .el-card .el-card__header {
  padding: 12px 16px;
  /* ===== 美化：虚线分隔 + 顶部浅渐变，提升层次 ===== */
  border-bottom: 1px dashed #eef1f6;
  background: linear-gradient(180deg, #fafbfd 0%, #ffffff 100%);
  .card-h-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }
}

.apvlPrcPayAdv {
  .s-fx {
    position: relative;
    z-index: 1;
    cursor: pointer;
    font-size: 13px;
    color: #409EFF;
    flex-shrink: 0;      /* 四列下“查看详情”不被压缩 */
    white-space: nowrap;
  }

  .s-fx::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: -0.25em;
    right: -0.25em;
    background-color: #F5F7FA;
    transform-origin: center right;
    transform: scaleX(0);
    transition: transform 0.2s ease-in-out;
  }

  .s-fx:hover::before {
    transform: scaleX(1);
    transform-origin: center left;
  }

  /* ===== 美化：文本域圆角 / 聚焦光晕 ===== */
  .el-card .el-textarea__inner {
    border-radius: 10px;
    border-color: #e6e9f0;
    background-color: #fbfcfe;
    transition: border-color .2s, box-shadow .2s, background-color .2s;
  }
  .el-card .el-textarea__inner:hover { border-color: #cdd6e6; }
  .el-card .el-textarea__inner:focus {
    border-color: #93c5fd;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, .1);
    background-color: #fff;
  }

  /* ===== 美化：提交按钮圆角 + 渐变 ===== */
  .el-card .el-button--primary {
    border: none;
    border-radius: 10px;
    font-weight: 600;
    letter-spacing: .5px;
    background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
    box-shadow: 0 8px 18px -10px rgba(59, 130, 246, .9);
    transition: transform .15s, box-shadow .2s, filter .2s;
  }
  .el-card .el-button--primary:hover {
    color: #fff;
    background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
    filter: brightness(1.05);
    transform: translateY(-1px);
    box-shadow: 0 12px 22px -10px rgba(59, 130, 246, .95);
  }
  .el-card .el-button--primary:active { transform: translateY(0); }
}

.apvlPrcPayAdv .itemHeight {
  height: 326px;
}

/* ===== 优化：补作用域前缀，避免影响其他页面的同名 class ===== */
.apvlPrcPayAdv .card-h-wrapper .title {
  font-size: 15px;                       /* 四列下略小，标题更耐放 */
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 22px;
  margin-right: 8px;
  max-width: calc(100% - 72px);          /* 固定给“查看详情”留位，标题稳定省略 */
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.apvlPrcPayAdv div.right-count {
  font-size: 14px;
  line-height: 30px;
}
</style>
